import { defined } from "common/Support";
import * as React from "react";
import { shallowEqual } from "react-redux";
import { usePreviousValue } from "hooks/use-previous-prop";

export function useCleanupMemo<T>(factory: () => [T, () => void], deps: React.DependencyList): T {
    const lastDeps = usePreviousValue(deps);
    const next = shallowEqual(lastDeps, deps) ? undefined : factory();

    const ref = React.useRef<[T, () => void]>();

    if (next !== undefined) {
        if (ref.current !== undefined) {
            ref.current[1]();
        }
        ref.current = next;
    }

    return defined(ref.current)[0];
}
